import { Box, Heading } from "@ogt/ui";
import LocalTrafficSearch from "src/components/LocalTraffic/LocalTrafficSearch";

export default function LocalTraffic() {
  return (
    <>
      <Box>
        <Heading className="mb-4">Kolla om du kan resa med närtrafiken</Heading>
        <LocalTrafficSearch />
      </Box>
    </>
  );
}
